export default __webpack_public_path__ + "static/media/rocket_anim_90.5c41fb45.png";